function klevu_uc_showProductData(k) {
    var g = "", f = "", i = false, c = "klevu-saleprice", b = "", l, j, e = false, m = "", d, a = document.createElement("div"), h = k.additionalDataToReturn ? JSON.parse(k.additionalDataToReturn) : false;
    k = klevu_productCustomizations(k);
    k.additionalFlags = h;
    const tags = k.tags.split(",");
    if (k.productImage.trim().length === 0) {
        k.productImage = klevu_userOptions.noImageUrl
    }
    if (klevu_userOptions.openProductClicksInNewWindow) {
        b = ' target="_blank"'
    } else {
        b = ' onclick="klevu_analytics.stopClickDefault( event );" target="_self"'
    }
    m = "{data: {code: '" + escape(k.productCode) + "',url: '" + escape(k.productUrl) + "',name: '" + escape(k.productName) + "',salePrice: '" + escape(k.salePrice) + "',rating: '" + escape(k.rating) + "',position: " + k.productPosition + ",category: '" + escape(k.category) + "',sku: '" + escape(k.sku) + "',itemGroupId: '" + escape(k.productItemGroupId) + "'}}";
    g += "<li>";
    /* Start : CUSTOM CODE INJECTED */
    if(tags.some(tag => tag.includes('coming soon'))) {
        g +=`<span class="badge coming-soon">
                    Coming soon
            </span>`
    }

    /* End : CUSTOM CODE INJECTED  */

    g += '<a href="' + k.productUrl.replace(/"/g, "%22") + '" class="klevu-result-box" ';
    if (klevu_commons.isMobileDevice()) {
        g += ' onclick="return  klevu_analytics.trackClickedProduct(event, ' + m + ');" target="_self" >'
    } else {
        g += ' onmousedown="return  klevu_analytics.trackClickedProduct(event, ' + m + ');"  onkeydown="return klevu_eventHandler.handleElementKeydownEvent(event, ' + m + ', klevu_analytics.trackClickedProduct);" ' + b + " >"
    }
    a.innerHTML = k.productName;
    d = a.textContent || a.innerText || "";
    g += '<div class="klevu-img-wrap"><img src="' + k.productImage + '" onerror="this.onerror=null;this.src=\'' + klevu_userOptions.noImageUrl + '\';" alt="' + klevu_commons.escapeHtml(d) + '"/></div>';
    if ("undefined" !== typeof klevu_showDiscountBadge && klevu_showDiscountBadge && k.discount != "" && k.discount != "0" && k.discount != "0.0") {
        if (klevu_uiLabels.discountBadgeText.indexOf("#") === -1) {
            g += '<div class="klevu-discount-badge">' + klevu_uiLabels.discountBadgeText + " " + Number(k.discount).toFixed(0) + "%</div>"
        } else {
            g += '<div class="klevu-discount-badge">' + klevu_uiLabels.discountBadgeText.replace("#", Number(k.discount).toFixed(0) + "%") + "</div>"
        }
    }
    g += '<div class="klevu-name-desc"><div class="klevu-name">' + k.productName + '</div><div class="klevu-desc">' + k.productDescription + "</div>";
    g += klevu_userOptions.showRatingsOnQuickSearches !== false ? klevu_productElements.showRating(k, klevu_userOptions.showRatingsCountOnQuickSearches) : "";
    g += "</div>";
    g += '<div class="klevu-price">';
    if (klevu_showPrices) {
        g += klevu_productElements.showPrices(k, c)
    }
    if (klevu_userOptions.vatCaption.trim().length > 0) {
        g += '<div class="klevu-vat-caption">(' + klevu_userOptions.vatCaption + ")</div>"
    }
    if (k.totalProductVariants && k.totalProductVariants != "0") {
        g += '<div class="klevu-variants">+' + k.totalProductVariants + " " + klevu_uiLabels.variants + "</div>"
    }
    if (klevu_userOptions.outOfStockCaption.trim().length > 0) {
        if ((k.inStock) && k.inStock === "no") {
            g += '<div class="klevu-out-of-stock">' + klevu_userOptions.outOfStockCaption + "</div>"
        }
    }
    g += "</div>";
    g += '<div class="klevu-clear-left"></div>';
    g += "</a>";
    if (klevu_commons.showAddToCartButton(k.inStock, k.hideAddToCart)) {
        g += klevu_productElements.showAddtocart(k)
    }
    g += "</li>";
    return g

}